import React from "react";
import AccessCardFormFields from "components/AccessCardFormFields";
import AccessLevelFormFields from "components/AccessLevelFormFields";
import { fetchOne } from "actions/user";
import * as accessLevelActions from "actions/accessLevel";
import * as accessCardActions from "actions/accessCard";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as R from "ramda";
import UserFormFields from "components/UserFormFields";

const mapStateToProps = state => ({
  user: state.user.item,
  isCreatingAccessCard: state.accessCard.isCreating,
  isCreatingAccessLevel: state.accessLevel.isCreating
});

const mapDispatchToProps = {
  fetchOne,
  createAccessLevel: accessLevelActions.createOne,
  createAccessCard: accessCardActions.createOne
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeForm: null,
      accessCard: {
        firstname: "",
        surname: "",
        access_levels: [""],
        pin: "",
        note: ""
      },
      accessLevel: {
        name: "",
        note: "",
        readers: ["", ""]
      },
      user: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    const { user } = this.props;
    if (user.id !== nextProps.user.id) {
      this.handleChange(["user"], nextProps.user);
    }
  }

  componentWillMount() {
    this.props.fetchOne(this.props.match.params.token);
  }

  setActiveForm = form => {
    this.setState(prevState => ({
      activeForm: form
    }));
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  handleReaderChange = (idx, value) => {
    if (value != null) {
      const { user } = this.props;
      value = R.find(R.propEq("id", ~~value), user.readers);
    }
    this.setState(R.assocPath(["accessLevel", "readers", idx], value));
  };

  handleSubmit = event => {
    event.preventDefault();
    const { createAccessCard, createAccessLevel, match, history } = this.props;
    const { accessCard, accessLevel, activeForm, user } = this.state;
    if (activeForm === "accessCard") {
      const data = {
        ...accessCard,
        user_id: user.id,
        orderer: user.orderer,
        access_levels: accessCard.access_levels.filter(r => !!r)
      };

      createAccessCard(data, match.params.token)
        .then(data => {
          history.push("/access_card_submitted");
        })
        .catch(error => {
          this.handleChange(["status"], error);
        });
    } else if (activeForm === "accessLevel") {
      const data = {
        ...accessLevel,
        readers: accessLevel.readers.filter(r => !!r).map(({ id }) => id),
        user_id: user.id,
        orderer: user.orderer
      };
      createAccessLevel(data, match.params.token)
        .then(data => {
          history.push("/access_level_submitted");
        })
        .catch(error => {
          this.handleChange(["status"], error);
        });
    }
  };

  render() {
    const { activeForm, accessCard, accessLevel, status, user } = this.state;
    const { isCreatingAccessCard, isCreatingAccessLevel } = this.props;
    let formFields;

    if (!user.location) {
      return <div>Laster lokasjon.</div>;
    }

    switch (activeForm) {
      case "accessCard":
        formFields = (
          <AccessCardFormFields
            onChange={this.handleChange}
            accessCard={accessCard}
            user={user}
          />
        );
        break;
      case "accessLevel":
        formFields = (
          <AccessLevelFormFields
            onChange={this.handleChange}
            onReaderChange={this.handleReaderChange}
            accessLevel={accessLevel}
            user={user}
            note
          />
        );
        break;
      default:
        formFields = null;
    }
    return (
      <div className="col-md-6" style={{ margin: "0 auto" }}>
        <form onSubmit={this.handleSubmit}>
          <UserFormFields user={user} onChange={this.handleChange} disabled />
          {formFields}
          {formFields !== null ? (
            <div className="form-group">
              <button
                id="submit"
                name="submit"
                className="btn btn-primary"
                disabled={isCreatingAccessLevel || isCreatingAccessCard}
              >
                Send inn
              </button>
            </div>
          ) : (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-primary btn-lg btn-block"
                onClick={() => this.setActiveForm("accessCard")}
              >
                Bestill Adgangskort
              </button>
              <button
                type="button"
                className="btn btn-primary btn-lg btn-block"
                onClick={() => this.setActiveForm("accessLevel")}
              >
                Bestill/Endre Adgangsnivå
              </button>
            </React.Fragment>
          )}
        </form>
        <div>{status}</div>
      </div>
    );
  }
}

export default R.compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js